module.exports = __webpack_public_path__ + "img/rank14.71431322.png";